module.exports = __webpack_public_path__ + "img/expo-cli.3407611f.svg";